var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaNonImmigrant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#00B4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.034 31.2a6.468 6.468 0 016.932 0 6.468 6.468 0 005.074.803 6.468 6.468 0 016.592 2.142 6.468 6.468 0 004.577 2.332 6.468 6.468 0 015.607 4.074 6.468 6.468 0 003.633 3.633 6.468 6.468 0 014.074 5.607 6.468 6.468 0 002.332 4.577 6.467 6.467 0 012.142 6.592 6.468 6.468 0 00.804 5.074 6.47 6.47 0 010 6.932 6.468 6.468 0 00-.804 5.074 6.467 6.467 0 01-2.142 6.592 6.468 6.468 0 00-2.332 4.577 6.468 6.468 0 01-4.074 5.607 6.468 6.468 0 00-3.633 3.633 6.468 6.468 0 01-5.607 4.074 6.467 6.467 0 00-4.577 2.332 6.467 6.467 0 01-6.592 2.142 6.468 6.468 0 00-5.074.804 6.47 6.47 0 01-6.932 0 6.468 6.468 0 00-5.074-.804 6.467 6.467 0 01-6.592-2.142 6.467 6.467 0 00-4.577-2.332 6.468 6.468 0 01-5.607-4.074 6.468 6.468 0 00-3.633-3.633 6.468 6.468 0 01-4.074-5.607 6.468 6.468 0 00-2.332-4.577 6.468 6.468 0 01-2.142-6.592 6.468 6.468 0 00-.804-5.074 6.468 6.468 0 010-6.932 6.468 6.468 0 00.804-5.074 6.468 6.468 0 012.142-6.592 6.468 6.468 0 002.332-4.577 6.468 6.468 0 014.074-5.607 6.468 6.468 0 003.633-3.633 6.468 6.468 0 015.607-4.074 6.468 6.468 0 004.577-2.332 6.468 6.468 0 016.592-2.142 6.468 6.468 0 005.074-.804z",
    fill: "#9BE2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50l1.41 2.058 2.394.706-1.522 1.978.07 2.494L42 56.4l-2.351.836.069-2.494-1.522-1.978 2.393-.706L42 50z",
    fill: "#E8F8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96 72l1.41 2.058 2.394.706-1.522 1.978.07 2.494L96 78.4l-2.351.836.069-2.494-1.522-1.978 2.393-.706L96 72z",
    fill: "#CAEFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 59l1.41 2.058 2.394.706-1.522 1.978.07 2.494L38 65.4l-2.351.836.069-2.494-1.522-1.978 2.393-.706L38 59z",
    fill: "#E8F8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92 82l1.41 2.058 2.394.706-1.522 1.978.07 2.494L92 88.4l-2.351.836.069-2.494-1.522-1.978 2.393-.706L92 82z",
    fill: "#CAEFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 69.5,
    r: 18.5,
    fill: "#9BE2FF",
    stroke: "#72D5FF",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96 69.5C96 53.208 82.792 40 66.5 40c-8.137 0-15.505 3.295-20.842 8.623M37 69.5C37 85.792 50.208 99 66.5 99a29.4 29.4 0 0020.311-8.106",
    stroke: "#E8F8FF",
    strokeWidth: 6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.154 66.23l.191-.066a26.38 26.38 0 0118.034.232v0a26.38 26.38 0 0019.001-.127l.096-.038M83.154 73.23l.191-.066a26.38 26.38 0 0118.034.232v0a26.38 26.38 0 0019.001-.127l.096-.038M83.154 80.23l.191-.066a26.38 26.38 0 0118.034.232v0a26.38 26.38 0 0019.001-.127l.096-.038M83.154 87.23l.191-.066a26.38 26.38 0 0118.034.232v0a26.38 26.38 0 0019.001-.127l.096-.038",
    stroke: "#008EC9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
export default SvgVisaNonImmigrant;